import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * OrcaTaskTokenUsage model — one row per orca agent run whose Claude
 * stream-json log was parsed for token usage (INF-525).
 *
 * The raw token counts and a derived USD cost estimate are persisted together
 * so reporting reads a single row without re-deriving cost. `phase` and
 * `attempt` are nullable run context (which orca_tasks phase / attempt the run
 * belonged to).
 *
 * @since 1.0.0
 */
export class OrcaTaskTokenUsage extends Model.Class<OrcaTaskTokenUsage>("OrcaTaskTokenUsage")({
  id: Model.Generated(Schema.String),

  orcaTaskId: Schema.String,

  sessionKey: Schema.String,

  phase: Schema.NullOr(Schema.String),
  attempt: Schema.NullOr(Schema.Number),

  inputTokens: Schema.Number,
  outputTokens: Schema.Number,
  cacheReadTokens: Schema.Number,
  cacheCreationTokens: Schema.Number,
  estimatedCostUsd: Schema.Number,
  messageCount: Schema.Number,

  /**
   * OL-60: the customer that owns this usage row, denormalized from the parent
   * task so per-customer cost reads never join; `null` = unowned legacy row.
   *
   * @since 1.0.0
   */
  customerId: Schema.NullOr(Schema.String),

  createdAt: Model.DateTimeInsertFromDate,
  updatedAt: Model.DateTimeUpdateFromDate,
}) {}
